import {
  Box,
  GreyGrey50,
  IconCircleInfo,
  InfoPopover
} from '@sequencehq/core-components'
import { inflect } from 'inflection'
import { useHubspotImportStages } from 'Customers/utils/useHubspotImportStages'

export const HubspotImportStagesInfo = () => {
  const { stageLabels } = useHubspotImportStages()

  const helpText =
    stageLabels.length > 0
      ? `Customers whose deals reached the ${stageLabels.join(
          ' or '
        )} ${inflect(
          'stage',
          stageLabels.length
        )} are available to import. To import others, update your HubSpot settings.`
      : 'Customers matching your configured deal stages are available to import. To import others, update your HubSpot settings.'

  return (
    <Box data-testid="hubspot.CustomerSelectionModal.infoPopover">
      <InfoPopover
        variant="info"
        minimal
        padding="0"
        placement="top"
        body={<Box width={300}>{helpText}</Box>}
        icon={<IconCircleInfo color={GreyGrey50} />}
      />
    </Box>
  )
}
